const UNITS: readonly (readonly [Intl.RelativeTimeFormatUnit, number])[] = [
  ['year', 365 * 24 * 60 * 60 * 1000],
  ['month', 30 * 24 * 60 * 60 * 1000],
  ['week', 7 * 24 * 60 * 60 * 1000],
  ['day', 24 * 60 * 60 * 1000],
  ['hour', 60 * 60 * 1000],
  ['minute', 60 * 1000],
];

/**
 * "3 days ago", "hace 3 días", "há 3 dias" — from `Intl`, not from a table of
 * translated fragments.
 *
 * `numeric: 'auto'` is what turns "1 day ago" into "yesterday" in every locale
 * that has a word for it, which is the whole reason to use the platform here
 * instead of interpolating a count into a string.
 */
export function formatRelativeTime(value: Date | string | number, formatLocale: string): string {
  const time = value instanceof Date ? value.getTime() : new Date(value).getTime();
  if (!Number.isFinite(time)) return '';

  const delta = time - Date.now();
  const formatter = new Intl.RelativeTimeFormat(formatLocale, { numeric: 'auto' });

  for (const [unit, size] of UNITS) {
    if (Math.abs(delta) >= size) {
      return formatter.format(Math.round(delta / size), unit);
    }
  }
  return formatter.format(0, 'second');
}
